export const SESSION_CARDS = [
  {
    id: 'session-decisions',
    icon: '◈',
    label: 'Decisions made',
    prompt: 'What did you decide?',
    type: 'structured-entry',
    core: true,
    config: { maxItems: 10, titleMaxChars: 140, contextMaxChars: 200 },
  },
  {
    id: 'session-parking',
    icon: '⊞',
    label: 'Parking lot',
    prompt: 'Park it for later',
    type: 'quick-list',
    core: true,
    config: { maxItems: 10, maxChars: 140 },
  },
  {
    id: 'session-followups',
    icon: '◷',
    label: 'Follow-ups',
    prompt: 'Things to check on',
    type: 'date-hint-list',
    core: false,
    config: { maxItems: 10, maxChars: 140, dateHintMaxChars: 20 },
  },
  {
    id: 'session-commitments',
    icon: '⊗',
    label: 'Commitments',
    prompt: 'Promises made',
    type: 'owner-list',
    core: false,
    config: { maxItems: 10, maxChars: 140 },
  },
  {
    id: 'session-talking-points',
    icon: '◐',
    label: 'Talking points',
    prompt: 'What to cover',
    type: 'toggle-list',
    core: true,
    config: {
      maxItems: 15,
      maxChars: 140,
      toggleMode: 'discussed',
      pullFromPrepCard: 'prep-topics',
    },
  },
  {
    id: 'session-feedback',
    icon: '↕',
    label: 'Feedback given',
    prompt: 'Feedback exchanged',
    type: 'feedback-entry',
    core: false,
    config: { maxItems: 10, maxChars: 200 },
  },
  {
    id: 'session-agreements',
    icon: '⊜',
    label: 'Agreements',
    prompt: 'What we aligned on',
    type: 'quick-list',
    core: false,
    config: { maxItems: 10, maxChars: 140 },
  },
  {
    id: 'session-questions',
    icon: '◦',
    label: 'Questions raised',
    prompt: 'Questions that came up',
    type: 'toggle-list',
    core: false,
    config: {
      maxItems: 10,
      maxChars: 140,
      toggleMode: 'status',
    },
  },
  {
    id: 'session-takeaway',
    icon: '◘',
    label: 'Key takeaway',
    prompt: 'One headline',
    type: 'single-input',
    core: true,
    config: { maxChars: 140, placeholder: 'The one thing to remember...', centered: true, fontSize: '14px' },
  },
  {
    id: 'session-rating',
    icon: '◑',
    label: 'Session rating',
    prompt: 'How useful was this 1:1?',
    type: 'dual-rating',
    core: false,
    config: {},
  },
  {
    id: 'session-one-change',
    icon: '↻',
    label: 'One change',
    prompt: "One thing you'll do differently",
    type: 'single-input',
    core: false,
    config: { maxChars: 140, placeholder: "I'll start... / I'll stop... / I'll try...", centered: false, fontSize: '13px' },
  },
  {
    id: 'session-next-priorities',
    icon: '△',
    label: 'Next priorities',
    prompt: 'Focus for the next period',
    type: 'numbered-list',
    core: true,
    config: { maxItems: 3, maxChars: 140 },
  },
  {
    id: 'session-notes',
    icon: '▤',
    label: 'Shared notes',
    prompt: 'Capture anything',
    type: 'textarea',
    core: true,
    config: {},
  },
]

export const SESSION_CORE_IDS = SESSION_CARDS.filter((c) => c.core).map((c) => c.id)
// ["session-decisions", "session-parking", "session-talking-points",
//  "session-takeaway", "session-next-priorities", "session-notes"]

export const SESSION_CARD_IDS = new Set(SESSION_CARDS.map((c) => c.id))

export function getSessionCard(id) {
  return SESSION_CARDS.find((c) => c.id === id)
}
